var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEmpresas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 25",
    style: {
      enableBackground: "new 0 0 26 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:#4D4D4D;}\n\t.st3{fill:none;stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:#D9002C;}\n\t.st5{fill:none;stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st6{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16.86,13.85h-1.09v1.76h1.09V13.85z M13.55,10.03h-1.09v1.76h1.09V10.03z M16.86,10.03h-1.09v1.76h1.09V10.03z  M13,1.95C7.18,1.95,2.45,6.68,2.45,12.5c0,5.82,4.73,10.55,10.55,10.55s10.55-4.73,10.55-10.55C23.55,6.68,18.82,1.95,13,1.95z  M13,21.96c-0.6,0-1.19-0.06-1.77-0.17h0.62v-2.5h2.29v2.5h0.62C14.19,21.9,13.6,21.96,13,21.96z M18.77,19.98 c-1.03,0.8-2.23,1.38-3.53,1.7v-3.49h-4.47v3.49c-1.3-0.32-2.5-0.9-3.53-1.7V7.99h11.53V19.98z M19.86,18.99V6.89H6.14v12.1 c-1.61-1.7-2.6-3.98-2.6-6.49c0-5.22,4.24-9.46,9.46-9.46s9.46,4.24,9.46,9.46C22.46,15.01,21.47,17.3,19.86,18.99z M10.23,13.85 H9.14v1.76h1.09V13.85z M10.23,10.03H9.14v1.76h1.09V10.03z M13.55,13.85h-1.09v1.76h1.09V13.85z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmpresas);
export default __webpack_public_path__ + "static/media/icon_empresas.2acb005cce99c78c5faa82e2651d4bbe.svg";
export { ForwardRef as ReactComponent };